const prefix = '/materiality-assessments';

export const MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG = `${prefix}`;
export const MATERIAL_ASSESSMENT_MANAGEMENT_RECORD_TAG = `${prefix}/id`;
export const MATERIAL_STAKEHOLDER_INVESTOR_TAG = `${prefix}/{maId}/stakeholders/investors`;
export const MATERIAL_STAKEHOLDER_BOARDS_TAG = `${prefix}/{maId}/stakeholders/boards`;
export const MATERIAL_STAKEHOLDER_EMPLOYEES_TAG = `${prefix}/{maId}/stakeholders/employees`;
export const MATERIAL_STAKEHOLDER_COMMUNITIES_TAG = `${prefix}/{maId}/stakeholders/communities`;
export const MATERIAL_STAKEHOLDER_SUPPLIERS_TAG = `${prefix}/{maId}/stakeholders/suppliers`;
export const MATERIAL_STAKEHOLDER_CUSTOMERS_TAG = `${prefix}/{maId}/stakeholders/customers`;
export const MATERIAL_STAKEHOLDER_NGO_TAG = `${prefix}/{maId}/stakeholders/ngos`;
export const MATERIAL_STAKEHOLDER_MEDIA_TAG = `${prefix}/{maId}/stakeholders/media`;
export const MATERIAL_STAKEHOLDER_COMPETITORS_TAG = `${prefix}/{maId}/stakeholders/competitors`;
export const MATERIALITY_STAKEHOLDER_ANALYSIS_TAG = `${prefix}/{maId}/stakeholders/analysis`;

export const MATERIALITY_TOPICS_LIST_TAG = `${prefix}/{maId}/topics/groups`;
export const MATERIALITY_TOPICS_LIST_DISCLOSURES_TAG = `${prefix}/{maId}/disclosures/groups`;
export const MATERIALITY_TOPICS_LIST_DISCLOSURES_DETAILS_TAG = `${prefix}/{maId}/disclosures/groups/{id}`;
export const MATERIALITY_IRO_TEMPLATES_IMPACTS_TAG = `${prefix}/{maId}/iro-impacts`;
export const MATERIALITY_IRO_TEMPLATES_RISKS_TAG = `${prefix}/{maId}/iro-risks`;
export const MATERIALITY_IRO_TEMPLATES_OPPORTUNITIES_TAG = `${prefix}/{maId}/iro-opportunities`;
export const MATERIALITY_IRO_EMAILS_TAG = `${prefix}/{maId}/iro-emails`;
export const MATERIALITY_TOPIC_REFINEMENT_TAG = `${prefix}/{maId}/topic-refinement`;
export const MATERIALITY_RESPONDENT_LIST_TAG = `${prefix}/recipient/users/list`;

export const MATERIAL_STAKEHOLDER_GEO_TAG = `${prefix}/{maId}/geographic-risks`;
export const MATERIAL_STAKEHOLDER_GEO_DETAILS_TAG = `${prefix}/{maId}/geographic-risks/{id}`;

export default MATERIAL_ASSESSMENT_MANAGEMENT_LIST_TAG;
